import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useState, type JSX } from 'react';
import { ActionMenu } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getDataTestAttributes } from 'shared/utils/get-data-test-attributes';
import { twMerge } from 'tailwind-merge';
import { actionMenuLinkItem } from '../action-menu-link-item';
import { ActionsInterface, ActionsRenderProps, CustomStateType } from './types';
export function ActionsRender(t0) {
  const $ = _c(36);
  const {
    actions,
    instance,
    caption,
    testAttributePostfix,
    actionsOrder,
    rowId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== actions.custom) {
    t1 = () => {
      const obj = {} as CustomStateType<T>;
      actions.custom?.forEach(value => {
        obj[value.name] = false;
      });
      return obj;
    };
    $[0] = actions.custom;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isCustomOpen, setIsCustomOpen] = useState(t1);
  let actionSideElements;
  let t2;
  if ($[2] !== actions.activate || $[3] !== actions.custom || $[4] !== actions.edit || $[5] !== actions.openLink || $[6] !== actions.remove || $[7] !== actions.settings || $[8] !== actionsOrder || $[9] !== caption || $[10] !== instance || $[11] !== isActivateOpen || $[12] !== isCustomOpen || $[13] !== isRemoveOpen || $[14] !== isSettingsOpen || $[15] !== rowId || $[16] !== t || $[17] !== testAttributePostfix) {
    actionSideElements = [];
    const openLinkRender = () => {
      if (actions.openLink) {
        return actions.openLink.map(el => {
          const shouldRender = el.shouldRender ? el.shouldRender(instance) : true;
          if (shouldRender) {
            return actionMenuLinkItem({
              isNext: el.isNext,
              openInNew: el.openInNew,
              dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-link-${el.name}-${rowId}`),
              id: `${el.name}-open-link`,
              href: el.setHref(instance),
              label: el.caption ? el.caption : t("dashboard.actions.title.open")
            });
          }
        });
      }
    };
    const customRender = () => {
      if (actions.custom) {
        return actions.custom.map(el_0 => {
          const shouldRender_0 = el_0.shouldRender ? el_0.shouldRender(instance) : true;
          const key = `${el_0.name}-modal`;
          const customActionRender = el_0.onActionRender ? el_0.onActionRender(isCustomOpen?.[el_0.name] || false, () => setIsCustomOpen(prev => ({
            ...prev,
            [el_0.name]: false
          })), instance, key) : undefined;
          if (shouldRender_0) {
            customActionRender && actionSideElements.push(<Fragment key={key}>{customActionRender}</Fragment>);
            const itemProps = {
              id: `${el_0.name}-custom`,
              dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-${el_0.name}-${rowId}`),
              onClick: async () => {
                setIsCustomOpen(prev_0 => ({
                  ...prev_0,
                  [el_0.name]: true
                }));
                if (el_0.onActionClick) {
                  ;
                  try {
                    setIsFetching(true);
                    await el_0.onActionClick(instance);
                    setIsFetching(false);
                  } catch (t3) {
                    setIsFetching(false);
                  }
                }
              },
              label: el_0.caption,
              disabled: el_0.disabled
            };
            return el_0.CustomActionMenuItem ? el_0.CustomActionMenuItem(itemProps) : itemProps;
          }
        });
      }
    };
    const settingsRender = () => {
      if (actions.settings) {
        const settings = actions.settings;
        const shouldRender_1 = actions.settings.shouldRender ? actions.settings.shouldRender(instance) : true;
        if (shouldRender_1) {
          actionSideElements.push(<EditModal key="settings-modal" opened={isSettingsOpen} onOpen={settings.onModalOpen} isPreFetching={settings.isFetching} onClose={() => {
            setIsSettingsOpen(false);
          }} fullCaption={settings.fullCaption} afterLeave={settings.onModalClose} caption={caption} editable={settings.editable} instance={instance} additionalData={settings.additionalData} onEdit={data => settings.onEdit(instance, data)} toastCaption={settings.toastCaption ? settings.toastCaption : t("dashboard.actions.updated", {
            module: caption
          })} />);
          return {
            id: "action-settings",
            onClick: () => {
              setIsSettingsOpen(true);
            },
            label: t("dashboard.actions.title.settings"),
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-settings-${rowId}`)
          };
        }
      }
    };
    const editRender = () => {
      if (actions.edit) {
        const shouldRender_2 = actions.edit.shouldRender ? actions.edit.shouldRender(instance) : true;
        const edit = actions.edit;
        if (shouldRender_2) {
          return actionMenuLinkItem({
            id: "action-edit",
            label: t("dashboard.actions.title.edit"),
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-link-${rowId}`),
            href: edit.setHref(instance),
            openInNew: edit.openInNew,
            isNext: edit.isNext
          });
        }
      }
    };
    const activateRender = () => {
      if (actions.activate) {
        const isActive = instance[(actions.activate.customStatusField || "active") as keyof T];
        const activate = actions.activate;
        const shouldRender_3 = actions.activate.shouldRender ? actions.activate.shouldRender(instance) : true;
        const confirmationText = actions.activate.confirmationText ? actions.activate.confirmationText : "dashboard.actions.activate_confirmation";
        if (shouldRender_3) {
          actionSideElements.push(<Confirmation key="activate-modal" status={isActive ? "error" : "normal"} confirmButtonCaption={isActive ? t("global.deactivate") : t("global.activate")} opened={isActivateOpen} onClose={() => setIsActivateOpen(false)} onConfirm={() => activate.onChange(instance)} confirmationText={t(confirmationText, {
            activate: isActive ? t("global.deactivate").toLowerCase() : t("global.activate").toLowerCase(),
            module: caption?.toLowerCase()
          })} toastCaption={t("dashboard.actions.activated", {
            module: caption,
            activated: isActive ? t("dashboard.actions.deactivated_caption").toLowerCase() : t("dashboard.actions.activated_caption").toLowerCase()
          })} />);
          const dataTestPostfix = isActive ? `option-deactivate-${rowId}` : `option-activate-${rowId}`;
          return {
            id: "action-activate",
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, dataTestPostfix),
            onClick: () => {
              setIsActivateOpen(true);
            },
            label: isActive ? t("dashboard.actions.title.deactivate") : t("dashboard.actions.title.activate")
          };
        }
      }
    };
    const removeRender = () => {
      if (actions.remove) {
        const remove = actions.remove;
        const shouldRender_4 = actions.remove.shouldRender ? actions.remove.shouldRender(instance) : true;
        if (shouldRender_4) {
          actionSideElements.push(<Confirmation status="error" key="remove-modal" opened={isRemoveOpen} onClose={() => setIsRemoveOpen(false)} onConfirm={() => remove.onChange(instance)} confirmationText={actions.remove.confirmationText ? actions.remove.confirmationText(instance) : t("dashboard.actions.remove_confirmation", {
            module: caption?.toLowerCase()
          })} title={actions.remove.confirmationTitle?.(instance)} toastCaption={actions.remove.showSuccessToast !== false && t("dashboard.actions.removed", {
            module: caption
          })} />);
          const itemProps_0 = {
            id: "action-remove",
            state: "destructive" as const,
            dataTestAttributes: getDataTestAttributes(!!testAttributePostfix, `option-remove-${rowId}`),
            onClick: () => {
              setIsRemoveOpen(true);
            },
            disabled: typeof remove.disabled === "function" ? remove.disabled(instance) : remove.disabled,
            label: actions.remove.CustomActionMenuItem ? undefined : t("dashboard.actions.title.remove")
          };
          return actions.remove.CustomActionMenuItem ? actions.remove.CustomActionMenuItem(itemProps_0, instance) : itemProps_0;
        }
      }
    };
    const getActionsToRender = () => {
      const actionsToRender = {
        openLink: openLinkRender,
        custom: customRender,
        settings: settingsRender,
        edit: editRender,
        activate: activateRender,
        remove: removeRender
      };
      const actionKeys = Object.keys(actionsToRender) as Array<keyof ActionsInterface<T, K>>;
      if (actionsOrder) {
        actionKeys.sort((a, b) => {
          const indexA = actionsOrder.indexOf(a);
          const indexB = actionsOrder.indexOf(b);
          return indexA - indexB;
        });
      }
      return actionKeys.map(key_0 => actionsToRender[key_0]);
    };
    t2 = getActionsToRender().flatMap(_temp).filter(_temp2);
    $[2] = actions.activate;
    $[3] = actions.custom;
    $[4] = actions.edit;
    $[5] = actions.openLink;
    $[6] = actions.remove;
    $[7] = actions.settings;
    $[8] = actionsOrder;
    $[9] = caption;
    $[10] = instance;
    $[11] = isActivateOpen;
    $[12] = isCustomOpen;
    $[13] = isRemoveOpen;
    $[14] = isSettingsOpen;
    $[15] = rowId;
    $[16] = t;
    $[17] = testAttributePostfix;
    $[18] = actionSideElements;
    $[19] = t2;
  } else {
    actionSideElements = $[18];
    t2 = $[19];
  }
  const renderActions = t2;
  const thereAreActionsToRender = renderActions.length > 0;
  const t3 = !thereAreActionsToRender && "invisible";
  let t4;
  if ($[20] !== t3) {
    t4 = twMerge("flex items-center", t3);
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t) {
    t5 = t("global.more_actions");
    $[22] = t;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const t6 = !!testAttributePostfix;
  const t7 = `options-${rowId}`;
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = getDataTestAttributes(t6, t7);
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== isFetching || $[28] !== renderActions || $[29] !== t5 || $[30] !== t8) {
    t9 = <ActionMenu ariaLabel={t5} isFetching={isFetching} dataTestAttributes={t8} menuItems={renderActions} />;
    $[27] = isFetching;
    $[28] = renderActions;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== actionSideElements || $[33] !== t4 || $[34] !== t9) {
    t10 = <div className={t4}>{t9}{actionSideElements}</div>;
    $[32] = actionSideElements;
    $[33] = t4;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}
function _temp2(item) {
  return Boolean(item);
}
function _temp(renderFunction) {
  return renderFunction();
}